import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Filters } from 'components/svg';
import { Button } from 'components/core/Button';

export default function FiltersButton({ children, className, onClick, link }) {
	return (
		<Button
			link={link}
			className={classnames('filters-button', className)}
			onClick={onClick}
		>
			<Filters />
			<span className="button-content">
				{ children || 'Filters' }
			</span>
		</Button>
	);
}

FiltersButton.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
	link: PropTypes.bool
};

FiltersButton.defaultProps = {
	link: true
};
